// --- Dependencies -------------------------------------------------------------------------------
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import usePermission from "@/hooks/usePermission";
// --- Logic --------------------------------------------------------------------------------------
type Props = { model: string; children: ReactNode };

/**
 * Hiding a tab is not enough — an admin can type the path. This sends them home instead, and the API
 * refuses the same segment anyway, so the two agree.
 *
 * Named for its counterpart in `clients-web` even though there are no admin roles: it gates on the
 * same `canAccess(model)` call, and one name for one job across the two apps is worth more than a
 * name that describes `isSuper` precisely.
 */
export default function RoleRoute({ model, children }: Props) {
    const { canAccess } = usePermission();
    if (!canAccess(model)) return <Navigate to="/" replace />;
    return <>{children}</>;
}
